import { SubmitOrderBasicInformations } from './SubmitOrderBasicInformations';

export class SubmitWithSinglePayment extends SubmitOrderBasicInformations {
    billingmethod: string;
    cardnumber?: string;
    expiryyear?: number;
    expirymonth?: number;
    cvv?: string;
    streetaddress?: string;
    streetaddress2?: string;
    city?: string;
    state?: string;
    zip?: string;
    saveonfile?: boolean;
    billingaccountid?: string;
    billingschemeid?: number;
    billingfields?: Array<SubmitBillingFields>;
    cardtype?: string;
    cardlastfour?: string;
    token?: string;
}

class SubmitBillingFields {
    name: string;
    value: string;
}
